import {FilterKey} from "../interface/filter-key";
import {FilterControls} from "../interface/filter-controls";

export class StoryFilter {
	private static readonly KEYS: FilterKey[] = [
		{
			key: 'inStock',
			name: 'SHOW IN-STOCK ONLY',
			type: "toggle"
		},
		{
			key: 'segment_category',
			subKey: 'sub_category',
			name: 'Craft',
			type: 'sub'
		},
		{
			key: 'color',
			name: 'Color',
			type: 'csv'
		},
		{
			key: 'material',
			name: 'Material',
			type: 'csv'
		},
		{
			key: 'pattern',
			name: 'Pattern',
			type: 'csv'
		},
		{
			key: 'calculatedPrice',
			name: 'Price',
			type: 'range'
		}
	];

	public static get(): FilterControls {
		return {
			keys: StoryFilter.KEYS,
			cohorts: []
		}
	}
}
